// 此文件下的路由不需要登录
export default [
  {
    path: '/login',
    name: 'login',
    meta: { title: '登录', name: '登录', needLogin: false },
    component: () => import('/@/layout/Login.vue')
  },
  {
    path: '/plan-gate',
    name: 'planGate',
    meta: { title: '套餐选择', name: '套餐选择', needLogin: true },
    component: () => import('/@/views/PlanGate.vue')
  },
  {
    name: 'register',
    path: '/register',
    meta: {
      title: '注册',
      needLogin: false
    },
    component: () => import('/@/layout/Register.vue')
  },
  {
    name: '404',
    path: '/404',
    meta: {
      title: '404',
      needLogin: false
    },
    component: () => import('/@/views/exception/404.vue')
  },
  {
    name: 'not-found',
    path: '/:pathMatch(.*)*',
    meta: {
      title: 'not-found',
      needLogin: false
    },
    component: () => import('/@/views/exception/404.vue')
  }
]
